
import { getStoreUuid } from '../utils/tool';
enum FireBaseStatus { Prepare, Pending, Succ, Fail }

declare var firebase: any;
class initFireBase {
    private scriptList: Array<string> = [
        'https://www.gstatic.com/firebasejs/7.4.0/firebase-app.js',
        'https://www.gstatic.com/firebasejs/7.4.0/firebase-analytics.js'
    ]
    private pendingEvent: Array<string> = []
    private loadStatus: FireBaseStatus = FireBaseStatus.Prepare
    constructor() {
        this.loadStatus = FireBaseStatus.Pending;
        this.initFireBase()
    }
    private async initFireBase() {
        for (let i = 0; i < this.scriptList.length; i++) {
            const loadResult = await this.loadScript(this.scriptList[i])
            if (!loadResult) {
                this.loadStatus = FireBaseStatus.Fail;
                return
            }
        }
        this.loadStatus = FireBaseStatus.Succ;
        this.initFireBaseConfig();
        this.analyticsEventInPending();
    }
    private initFireBaseConfig() {
        var firebaseConfig = {
            apiKey: "AIzaSyDTBMXedqM4A76YP3PeyWUhATAx38O6R1E",
            authDomain: "pondopeso.firebaseapp.com",
            databaseURL: "https://pondopeso.firebaseio.com",
            projectId: "pondopeso",
            storageBucket: "pondopeso.appspot.com",
            messagingSenderId: "223854709248",
            appId: "1:223854709248:web:e84924c05c3b43fdfba6e5",
            measurementId: "G-CXFSZJCQVW"
        };

        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        const ans = firebase.analytics();
        ans.setUserId(getStoreUuid());
    }
    private loadScript(scriptSrc: string): Promise<boolean> {
        console.log(scriptSrc)
        return new Promise(resolve => {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.onload = function () {
                resolve(true)
            }
            script.onerror = function () {
                resolve(false)
            }
            document.body.appendChild(script)
        })
    }
    private analyticsEventInPending() {
        this.pendingEvent.forEach(this.analyticsEvent)
    }
    analyticsEvent= (event: string) => {
        switch (this.loadStatus) {
            case FireBaseStatus.Prepare:
            case FireBaseStatus.Pending:
                this.pendingEvent.push(event)
                break;
            case FireBaseStatus.Succ:
                firebase.analytics().logEvent(event)
                // logEvent(event)
                console.log(event)
                break
            default:
                break
        }
       
    }

}
const fb = new initFireBase(); 
export default function analytics(event: string) {
    // console.log(event)
    fb.analyticsEvent(event);
}

